"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useEffect, useState } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export function ReactQueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            refetchOnWindowFocus: false,
            retry: 1, // Retry failed requests once
            retryOnMount: false, // Do not retry failed queries again when remounting
          },
        },
      }),
  );

  // iOS WKWebView restores pages from bfcache as a frozen snapshot on history
  // back: React does not re-mount and useEffects do not re-run, so queries
  // never refetch. Detect the restore via `pageshow` and refresh active queries.
  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      console.log("Page show event:", event);
      if (event.persisted) {
        queryClient.invalidateQueries();
      }
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
